export { default as BoxTabs } from './BoxTabs';
